<template>
  <div>
    <div class="levo__menu" v-if="activeOnly === false || activeGame.active === true">
      <div
        class="levo__menu__item"
        v-for="item in allGameTabs"
        :key="item.component"
        :class="{ active: isItemActive(item.component) }"
        v-on:click="selectItem(item.component)"
      >
        <div class="levo__menu__item__obsah">
          <div class="levo__menu__item__obsah__text">{{ item.name }}</div>

          <div class="levo__menu__item__obsah__obrazek">
            <div :class="item.iconClass"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "LevoMenu",
  data: function () {
    return {
      activeOnly: true,
      allGameTabs: [
        {
          name: "Game Overview",
          component: "GameOverview",
          iconClass: "gameOverview",
          activeOnly: false,
        },
        {
          name: "Edit Products",
          component: "EditProducts",
          iconClass: "editProducts",
          activeOnly: true,
        },
        {
          name: "Set Campaigns",
          component: "SetCampaigns",
          iconClass: "setCampaigns",
          activeOnly: true,
        },
        {
          name: "Data",
          component: "PurchaseData",
          iconClass: "purchaseData",
          activeOnly: true,
        },
      ],
    };
  },
  computed: {
    ...mapGetters(["activeGame"]),
  },
  methods: {
    selectItem: function (item) {
      this.$router.push("/game/" + item);
    },
    isItemActive: function (name) {
      return "Game." + name == this.$route.name;
    },
  },
};
</script>
